angular.module('omega').service('AuthService', function ($http, AUTH_SERVER_URL) {

    this.getUser = function () {
        return $http.get(AUTH_SERVER_URL, {withCredentials: true}).then(function (results) {
            return results.data;
        });
    };

});
